package xyz.luan.bpc.parser

data class ParsingContext(
    val name: String,
) {
    fun fail(message: String): Nothing = throw ParsingException("$name: $message")
}

class ParsingException(message: String) : RuntimeException(message)
